import { render, staticRenderFns } from "./Editpass_sign.vue?vue&type=template&id=3dba00a5&scoped=true"
import script from "./Editpass_sign.vue?vue&type=script&lang=js"
export * from "./Editpass_sign.vue?vue&type=script&lang=js"
import style0 from "./Editpass_sign.vue?vue&type=style&index=0&id=3dba00a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba00a5",
  null
  
)

export default component.exports